const COMPLETE_RETRY_DELAY_MS = 1000;

const waitForCompleteRetry = () =>
  new Promise((resolve) => {
    setTimeout(resolve, COMPLETE_RETRY_DELAY_MS);
  });

export const retryCompleteRequest = async (request, { onRetry } = {}) => {
  try {
    return await request();
  } catch (error) {
    if (error?.response?.status !== 412) {
      throw error;
    }

    if (onRetry) {
      onRetry({ error, retryDelayMs: COMPLETE_RETRY_DELAY_MS });
    }

    await waitForCompleteRetry();
    return retryCompleteRequest(request, { onRetry });
  }
};
